// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3180":"4a4cac89","4857":"b9d23a8f","7165":"c98d9b2d","9081":"b9d23a8f"}[chunkId] + ".chunk.css";
};